"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueClosingSoonDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class VenueClosingSoonDto {}
exports.VenueClosingSoonDto = VenueClosingSoonDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueClosingSoonDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueClosingSoonDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'ISO-8601 timestamp when the venue closes.'
}), __metadata("design:type", String)], VenueClosingSoonDto.prototype, "closesAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Minutes remaining until close at the time the event was sent.'
}), __metadata("design:type", Number)], VenueClosingSoonDto.prototype, "minutesRemaining", void 0);
//# sourceMappingURL=VenueClosingSoon.dto.js.map